import {
  SEARCH_MY_JOBS_data,
  SET_ACTIVE_JOB_TYPE,
  SET_JOB_STATUS,
  GET_ALL_JOBS,
  GETTING_ALL_JOBS,
  SET_ALL_JOBS,
  GET_ALL_JOBS_ERROR,
  UPDATE_JOB,
  UPDATE_JOB_SUCCESS,
  SET_NOTIFICATION_JOB,
  ADD_EVIDENCE_JOB,
  ADD_EVIDENCE_JOB1,
  GET_EVIDENCE_JOB,
  GET_EVIDENCE_JOB_MIDDLEWARE,
  LOADER,
  ADD_EVIDENCE_JOB_ERROR,
  ADD_EVIDENCE_JOB_SUCCESS,
  LANGUAGE_CHANGES,
  GET_ACTIVE_FILL,
  SET_ACTIVE_FILL,
  JOB_DETAIL,
  GET_ACTIVE_RENT_ARRANGE,
  SET_ACTIVE_RENT_ARRANGE,
  CREATE_JOB,
  SET_CREATE_JOB,
  SELECT_SENDER_DATA,
  SELECT_CYLINDER_DATA,
  SELECT_TRANSPORT_DATA,
  TRANSPORT_DATA_LIST,
  SELECT_DEALER_DATA,
  SELECT_CONTRACTOR_DATA,
  SELECT_RECYCLE_FACTORY_DATA,
  SELECT_BUILDING_DATA,
  SELECT_BORROWED_DATA,
  ALL_CYLINDER,
  DISPLAY_TABLE_CYLINDER,
  PAYLOAD_DEALER,
  PAYLOAD_CONTRACTOR,
  PAYLOAD_RECYCLE_FACTORY,
  PAYLOAD_TRANSPORT,
  FILL_TOOL,
  RECOVERY_TOOL,
  REFRIGERATOR_EQUIP,
  RECOVERY_REFRIGERATOR_EQUIP,
  MULTI_IMAGE,
  SET_IMAGE,
  RECOVERY_REF_CYLINDER,
  SET_REF_INDEX,
  SET_AC_INDEX,
  CREATE_RECOVERY_AND_FILL_JOB,
  GET_ALL_JOB_VIEW,
  GET_ALL_JOB_VIEW_DATA,
  UPDATE_CYLINDER_JOB,
  JOB_UPDATE_PAYLOAD,
  FILL_RECOVERY_JOB_CREATE,
  GET_JOB_ID,
  GET_SINGLE_JOB,
  SET_SINGLE_JOB,
  GET_UPDATE_API_DATA,
  UPDATE_FLAG,
  DELETE_CYLINDER_EQUIPMENT,
  RESET_JOB_INIT_STATE,
  RENTAL_EDIT_FLAG,
  EDIT_RENTAL_JOB,
  RENTAL_STATUS,
  SELECT_RECEIVER_DATA,
  EDIT_INFO,
  ADD_RECYCLE_JOB,
  ADD_COMPLETE_RECYCLE_JOB,
  QR_SEARCH_CYLINDER_VALIDATION,
  SET_QR_CYLINDER_VALIDATION,
  GET_QR_CYLINDER_DATA,
  SET_QR_CYLINDER_DATA,
  SET_SCANNER_TYPE,
  SET_DEFAULT_CAPACITY_VALUE,
  FILL_RECOVERY_INDEX,
  RECOVERY_CYLINDER_INDEX,
  RECOVERY_CYLINDER_ARRAY,
  UPDATE_AWAITING_DATA,
  SET_QUICK_LINK_TYPE,
  UPDATE_PROCESS_CERTIFICATE,
  SET_CUSTOMER_BUILDING_UPDATE,
  RECOVERY_CAR_AC,
  FILL_CAR_AC,
  RECOVERY_CAR_AC_CYLINDER,
  SET_FILTERED_CONTRACTOR,
  SEARCH_USER,
  SET_SEARCH_USER,
  BUILDING_USER_SEARCH,
  SET_OWNED_BORROWED_CYLINDER,
  SET_MULTI_SELECTED_CYLINDER,
  SELECT_DISPOSE_CONTRACTOR_DATA,
  SET_100KG_TRANSFER_CYLINDER,
  UPDATE_PROCESS_JOB,
  ADD_REVIEW,
  GET_REVIEW,
  SET_REVIEW,
  CUSTOMER_ID,
  BUILDING_ID,
  TRANSPORT_SEND_RETURN,
  RECYCLE_JOB_CREATE,
  UPDATE_REFRIGERANT_VOLUME,
  UPDATE_JOB_COMPLETE,
  RESET_JOB_ACTION,
  BRAND_OPTIONS_LIST,
  SET_EQUIPMENT_DETAIL_FLAG,
  SET_UPDATED_JOB_EQUIPMENT_DETAIL,
  SEARCH_MY_JOBS, LOADER_FLAG, MULTI_DEALER_ADD, ALL_RESET_JOB_ACTION,
  SHARE_CERTIFICATE,
  JOB_REVERT,
  RENTAL_JOB_TYPE,
  SHOW_LIST_FLAG,
  CONFIRMATION_EDIT_FLAG,
  SET_RECEPTION_CYLINDER_DATA,
  UPDATE_HISTORY,
  SET_UPDATE_HISTORY,
  SET_MESSAGE_DATA,
  JOB_FLAG,
  DEALER_JOB_FLAG, SET_QR_RESULT_DATA, SET_JOB_READ, GET_CONFIRMATION_REPORT, SET_CONFIRMATION_REPORT, SEARCH_QR_JOBS, FISCAL_YEAR_LIST,
  SET_FISCAL_YEAR_LIST,
  SET_JOB_SEARCH_VALUE,
  UPDATE_RENT_RETURN,
  ISSUE_DETAILS,
  BRAND_PRODUCT_MODEL_DETAILS,
  SET_FILL_RECOVERY_TYPE,
  SET_LOT_LIST,
  FILL_OTHER_CYLINDER,
  FILL_REF_CYLINDER,
  FILL_AC_CYLINDER
} from "./types";

export const editInfoData = (payload) => ({
  type: EDIT_INFO,
  payload: payload,
});

export const issueDetails = (payload) => ({
  type: ISSUE_DETAILS,
  payload: payload,
});

export const setDefaultCapacityValue = (payload) => ({
  type: SET_DEFAULT_CAPACITY_VALUE,
  payload: payload,
});
export const recoveryCylinderIndex = (payload) => ({
  type: RECOVERY_CYLINDER_INDEX,
  payload: payload,
});
export const fillAndRecoveryFormIndex = (payload) => ({
  type: FILL_RECOVERY_INDEX,
  payload: payload,
});
export const setJobType = (payload) => ({
  type: SET_ACTIVE_JOB_TYPE,
  payload,
});
export const rentalStatus = (payload) => ({
  type: RENTAL_STATUS,
  payload,
});
export const rentalEditFlag = (payload) => ({
  type: RENTAL_EDIT_FLAG,
  payload,
});
export const editRentalJob = (payload, msg) => ({
  type: EDIT_RENTAL_JOB,
  payload,
  msg
});
export const setJobStatus = (payload) => ({
  type: SET_JOB_STATUS,
  payload,
});
export const getAllJobs = (payload) => ({
  type: GET_ALL_JOBS,
  payload,
});
export const gettingAllJobs = () => ({
  type: GETTING_ALL_JOBS,
});
export const setAllJobs = (payload) => ({
  type: SET_ALL_JOBS,
  payload,
});
export const getAllJobsError = (err) => ({
  type: GET_ALL_JOBS_ERROR,
  err,
});

export const updateJob = (payload) => ({
  type: UPDATE_JOB,
  payload,
});

export const updateJobSuccess = (payload) => ({
  type: UPDATE_JOB_SUCCESS,
  payload,
});

export const setNotificationJob = (payload) => ({
  type: SET_NOTIFICATION_JOB,
  payload,
});

export const AddJobEvidence = (payload) => ({
  type: ADD_EVIDENCE_JOB,
  payload,
});

export const AddJobEvidence1 = (payload) => ({
  type: ADD_EVIDENCE_JOB1,
  payload: payload,
});
export const AddJobEvidenceError = () => ({
  type: ADD_EVIDENCE_JOB_ERROR,
});
export const AddJobEvidenceSuccess = (payload) => ({
  type: ADD_EVIDENCE_JOB_SUCCESS,
  payload,
});

export const getJobEvidence = (payload) => ({
  type: GET_EVIDENCE_JOB,
  payload,
});

export const getJobEvidenceMiddleware = (payload) => ({
  type: GET_EVIDENCE_JOB_MIDDLEWARE,
  payload: payload,
});

export const apiLoader = (payload) => ({
  type: LOADER,
  payload: payload,
});

export const languageChange = (payload) => ({
  type: LANGUAGE_CHANGES,
  payload: payload,
});

export const getActiveFill = (payload, dataId) => ({
  type: GET_ACTIVE_FILL,
  payload,
  dataId,
});

export const setActiveFill = (payload) => ({
  type: SET_ACTIVE_FILL,
  payload,
});

export const getActiveRentArrange = (payload) => ({
  type: GET_ACTIVE_RENT_ARRANGE,
  payload
});

export const setActiveRentArrange = (payload) => ({
  type: SET_ACTIVE_RENT_ARRANGE,
  payload,
});

export const jobDetail = (status, tab) => ({
  type: JOB_DETAIL,
  status,
  tab,
});

export const createJob = (payload, msg) => ({
  type: CREATE_JOB,
  payload,
  msg
});

export const setCreateJob = (payload) => ({
  type: SET_CREATE_JOB,
  payload,
});

export const selectSenderData = (payload) => ({
  type: SELECT_SENDER_DATA,
  payload,
});
export const selectReceiverData = (payload) => ({
  type: SELECT_RECEIVER_DATA,
  payload,
});
export const selectDealerData = (payload) => ({
  type: SELECT_DEALER_DATA,
  payload,
});
export const selectContractorData = (payload) => ({
  type: SELECT_CONTRACTOR_DATA,
  payload,
});
export const selectRecycleFactoryData = (payload) => ({
  type: SELECT_RECYCLE_FACTORY_DATA,
  payload,
});

export const selectDisposeContractorData = (payload) => ({
  type: SELECT_DISPOSE_CONTRACTOR_DATA,
  payload,
});

export const selectCylinderData = (payload) => ({
  type: SELECT_CYLINDER_DATA,
  payload,
});

export const setReceptionCylinderData = (payload) => ({
  type: SET_RECEPTION_CYLINDER_DATA,
  payload,
});

export const selectBorrowedData = (payload) => ({
  type: SELECT_BORROWED_DATA,
  payload,
});
export const allCylinder = (payload) => ({
  type: ALL_CYLINDER,
  payload,
});
export const displayTableCylinder = (payload) => ({
  type: DISPLAY_TABLE_CYLINDER,
  payload,
});
export const recoveryCarAcCylinder = (payload) => ({
  type: RECOVERY_CAR_AC_CYLINDER,
  payload,
});
//-----
export const recoveryRefCylinder = (payload) => ({
  type: RECOVERY_REF_CYLINDER,
  payload,
});

export const selectTransportData = (payload) => ({
  type: SELECT_TRANSPORT_DATA,
  payload,
});

export const selectBuildingData = (payload) => ({
  type: SELECT_BUILDING_DATA,
  payload,
});

export const transportDataList = (payload) => ({
  type: TRANSPORT_DATA_LIST,
  payload,
});

export const payloadDealer = (payload) => ({
  type: PAYLOAD_DEALER,
  payload,
});
export const payloadContractor = (payload) => ({
  type: PAYLOAD_CONTRACTOR,
  payload,
});
export const payloadRecycleFactory = (payload) => ({
  type: PAYLOAD_RECYCLE_FACTORY,
  payload,
});
export const payloadTransport = (payload) => ({
  type: PAYLOAD_TRANSPORT,
  payload,
});

export const fillTool = (payload) => ({
  type: FILL_TOOL,
  payload,
});

export const recoveryTool = (payload) => ({
  type: RECOVERY_TOOL,
  payload,
});

export const refrigeratorEquipment = (payload) => ({
  type: REFRIGERATOR_EQUIP,
  payload,
});

export const recoveryRefrigeratorEquipment = (payload) => ({
  type: RECOVERY_REFRIGERATOR_EQUIP,
  payload,
});

export const fillCarAcTool = (payload) => ({
  type: FILL_CAR_AC,
  payload,
});

export const recoveryCarAcTool = (payload) => ({
  type: RECOVERY_CAR_AC,
  payload,
});

export const multiImage = (payload) => ({
  type: MULTI_IMAGE,
  payload,
});

export const getAllJobView = (payload) => ({
  type: GET_ALL_JOB_VIEW,
  payload,
});

export const getAllJobViewData = (payload) => ({
  type: GET_ALL_JOB_VIEW_DATA,
  payload,
});
export const createRecoveryAndFillJob = (payload, msg) => ({
  type: CREATE_RECOVERY_AND_FILL_JOB,
  payload,
  msg
});

export const updateCylinderJob = (payload) => ({
  type: UPDATE_CYLINDER_JOB,
  payload,
});
export const fillRecoveryJobCreate = (payload) => ({
  type: FILL_RECOVERY_JOB_CREATE,
  payload,
});
export const jobUpdatePayload = (payload) => ({
  type: JOB_UPDATE_PAYLOAD,
  payload,
});

export const getJobId = (payload) => ({
  type: GET_JOB_ID,
  payload,
});

export const getSingleJobDetails = (payload) => ({
  type: GET_SINGLE_JOB,
  payload,
});
export const setSingleJobDetails = (payload) => ({
  type: SET_SINGLE_JOB,
  payload,
});
export const getUpdateApiData = (payload) => ({
  type: GET_UPDATE_API_DATA,
  payload,
});

export const updateFlag = (payload) => ({
  type: UPDATE_FLAG,
  payload,
});

export const deleteCylinder = (payload, msg) => ({
  type: DELETE_CYLINDER_EQUIPMENT,
  payload,
  msg
});

export const resetJobInitialState = (payload) => ({
  type: RESET_JOB_INIT_STATE,
  payload,
});

export const addRecycleJob = (payload, msg) => ({
  type: ADD_RECYCLE_JOB,
  payload,
  msg
});

export const addCompleteRecycleJob = (payload, msg) => ({
  type: ADD_COMPLETE_RECYCLE_JOB,
  payload,
  msg
});

export const qrSearchCylinderValidation = (payload) => ({
  type: QR_SEARCH_CYLINDER_VALIDATION,
  payload,
});

export const setQrSearchCylinderValidation = (payload) => ({
  type: SET_QR_CYLINDER_VALIDATION,
  payload,
});

export const getQRSearchCylinder = (payload) => ({
  type: GET_QR_CYLINDER_DATA,
  payload,
});

export const setQRSearchCylinder = (payload) => ({
  type: SET_QR_CYLINDER_DATA,
  payload,
});

export const setQRScannerType = (payload) => ({
  type: SET_SCANNER_TYPE,
  payload,
});
export const setRecoverCylinderArray = (payload) => ({
  type: RECOVERY_CYLINDER_ARRAY,
  payload,
});

export const updateFillRecoveryReceptionData = (payload) => ({
  type: UPDATE_AWAITING_DATA,
  payload,
});

export const setQuickLinksData = (payload) => ({
  type: SET_QUICK_LINK_TYPE,
  payload,
});

export const updateProcessCertificateData = (payload) => ({
  type: UPDATE_PROCESS_CERTIFICATE,
  payload,
});

export const setCustomerBuildingData = (payload) => ({
  type: SET_CUSTOMER_BUILDING_UPDATE,
  payload,
});

export const setFilteredContractorDetail = (payload) => ({
  type: SET_FILTERED_CONTRACTOR,
  payload,
});

export const searchUserData = (payload) => ({
  type: SEARCH_USER,
  payload,
});

export const searchUserBuildingData = (payload) => ({
  type: BUILDING_USER_SEARCH,
  payload,
});

export const setSearchUserData = (payload) => ({
  type: SET_SEARCH_USER,
  payload,
});

export const setOwnedBorrowedData = (payload) => ({
  type: SET_OWNED_BORROWED_CYLINDER,
  payload,
});

export const setMultiSelectedCylinders = (payload) => ({
  type: SET_MULTI_SELECTED_CYLINDER,
  payload,
});

export const set100KGTransferCylinder = (payload) => ({
  type: SET_100KG_TRANSFER_CYLINDER,
  payload,
});

export const updateProcessJobs = (payload, msg, scannerData) => ({
  type: UPDATE_PROCESS_JOB,
  payload,
  msg,
  scannerData
});
export const createJobId = (payload) => ({
  type: RECYCLE_JOB_CREATE,
  payload,
});

export const addReviews = (payload) => ({
  type: ADD_REVIEW,
  payload,
});

export const getReviews = (payload) => ({
  type: GET_REVIEW,
  payload,
});

export const setReviews = (payload) => ({
  type: SET_REVIEW,
  payload,
});
export const customerId = (payload) => ({
  type: CUSTOMER_ID,
  payload,
});
export const buildingId = (payload) => ({
  type: BUILDING_ID,
  payload,
});

export const setTransportSendReturn = (payload) => ({
  type: TRANSPORT_SEND_RETURN,
  payload,
});

export const updateRefrigerantVolumeJob = (payload) => ({
  type: UPDATE_REFRIGERANT_VOLUME,
  payload,
});

export const updateJobComplete = (payload) => ({
  type: UPDATE_JOB_COMPLETE,
  payload,
});

export const setEquipmentDetailsFlag = (payload) => ({
  type: SET_EQUIPMENT_DETAIL_FLAG,
  payload,
});

export const setUpdatedJobEquipmentDetails = (payload) => ({
  type: SET_UPDATED_JOB_EQUIPMENT_DETAIL,
  payload,
});

export const resetJobData = (payload) => ({
  type: RESET_JOB_ACTION,
  payload,
});

export const brandOptionsList = (payload) => ({
  type: BRAND_OPTIONS_LIST,
  payload,
});

export const setFillRecoveryType = (payload) => ({
  type: SET_FILL_RECOVERY_TYPE,
  payload,
});

export const setBrandProductModelDetails = (payload) => ({
  type: BRAND_PRODUCT_MODEL_DETAILS,
  payload,
});

export const searchMyJobs = (payload, pageNo) => ({
  type: SEARCH_MY_JOBS,
  payload,
  pageNo
});
export const searchMyJobsData = (payload) => ({
  type: SEARCH_MY_JOBS_data,
  payload,
});

export const loaderFlag = (payload) => ({
  type: LOADER_FLAG,
  payload,
});
export const multiDealerAdd = (payload) => ({
  type: MULTI_DEALER_ADD,
  payload,
});
export const resetAllJobData = (payload) => ({
  type: ALL_RESET_JOB_ACTION,
  payload,
});
export const shareCertificate = (payload, msg) => ({
  type: SHARE_CERTIFICATE,
  payload,
});
export const jobRevert = (payload) => ({
  type: JOB_REVERT,
  payload,
});

export const rentalJobType = (payload, msg) => ({
  type: RENTAL_JOB_TYPE,
  payload,
});

export const showListFlag = (payload,) => ({
  type: SHOW_LIST_FLAG,
  payload,
});

export const setConfirmationEditFlag = (payload, msg) => ({
  type: CONFIRMATION_EDIT_FLAG,
  payload,
});

export const updateHistory = ({ pageNo, payload, msg }) => ({
  type: UPDATE_HISTORY,
  pageNo,
  payload,
});
export const setUpdateHistory = (payload) => ({
  type: SET_UPDATE_HISTORY,
  payload,
});

export const setPopUpMessageData = (payload) => ({
  type: SET_MESSAGE_DATA,
  payload,
});
export const jobFlag = (payload) => ({
  type: JOB_FLAG,
  payload,
})
export const dealerJobFlag = (payload) => ({
  type: DEALER_JOB_FLAG,
  payload,
})

export const setQrResultData = (payload) => ({
  type: SET_QR_RESULT_DATA,
  payload,
});

export const setJobReadable = (payload) => ({
  type: SET_JOB_READ,
  payload,
});

export const getConfirmationJobReport = (payload) => ({
  type: GET_CONFIRMATION_REPORT,
  payload,
});

export const setConfirmationJobReport = (payload) => ({
  type: SET_CONFIRMATION_REPORT,
  payload,
});

export const searchQrJobs = (payload) => ({
  type: SEARCH_QR_JOBS,
  payload,
});
export const fiscalYearList = () => ({
  type: FISCAL_YEAR_LIST,
});
export const setFiscalYearList = (payload) => ({
  type: SET_FISCAL_YEAR_LIST,
  payload
});
export const setJobSearchValue = (payload) => ({
  type: SET_JOB_SEARCH_VALUE,
  payload
});
export const updateRentReturnAction = (payload) => ({
  type: UPDATE_RENT_RETURN,
  payload
});
export const setCylindersLotList = (payload) => ({
  type: SET_LOT_LIST,
  payload
});

export const fillACCylinder = (payload) => ({
  type: FILL_AC_CYLINDER,
  payload,
});
export const fillRefCylinder = (payload) => ({
  type: FILL_REF_CYLINDER,
  payload,
});
export const fillOtherCylinder = (payload) => ({
  type: FILL_OTHER_CYLINDER,
  payload,
});